import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';

export const useSearchDeliveryBoysApi = () => {
    const api = useContext(HimmaContext)!;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const searchDeliveryBoys = useCallback(
        async (name?: string, latitude?: number, longitude?: number) => {
            setLoading(true);
            setError(null);
            try {
                const response = await api.searchDeliveryBoys(name, latitude, longitude);
                return response.data;
            } catch (err) {
                setError(err instanceof Error ? err.message : 'An error occurred while searching delivery boys');
                throw err;
            } finally {
                setLoading(false);
            }
        },
        [api]
    );

    return {
        searchDeliveryBoys,
        loading,
        error,
    };
};
